import React from "react";
import TextFieldComponentLarge from "../TextFieldComponentLarge";

function AdmissionWrapUp({
  discoverMiraclesAsia,
  handleDiscoverMiraclesAsiaChange,
  therapistPreference,
  handleTherapistPreferenceChange,
}) {
  return (
    <div className="container-main-plan margin-bottom-2">
      <div className="tab-container-title-2B">Wrap up</div>

      <div className="tab-form-container-bis">
        <TextFieldComponentLarge
          title="How did you find out about Miracles Asia?"
          value={discoverMiraclesAsia}
          onChange={handleDiscoverMiraclesAsiaChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Any preference regarding therapist?"
          placeholder="e.g., gender"
          value={therapistPreference}
          onChange={handleTherapistPreferenceChange}
          showValidation={true}
        />
      </div>
    </div>
  );
}

export default AdmissionWrapUp;

